import { render, staticRenderFns } from "./AdministratorsComponent.vue?vue&type=template&id=807e9012&scoped=true"
import script from "./AdministratorsComponent.vue?vue&type=script&lang=js"
export * from "./AdministratorsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807e9012",
  null
  
)

export default component.exports